import { ChevronDown } from '@squareup/dex-icons/dex/control';
import { TrackedProps } from '@squareup/dex-types-shared-utils';
import { NativeButton } from '@squareup/dex-ui';
import { commonIconStyles } from '@squareup/dex-ui-shared-icon-styles';
import React, { ComponentProps, FC } from 'react';

import { ApiExplorerFieldSpecialValuesDropdown } from './ApiExplorerFieldSpecialValuesDropdown';
import styles from './api-explorer-field-helpers.module.css';

interface Props
  extends Pick<
    ComponentProps<typeof ApiExplorerFieldSpecialValuesDropdown>,
    'path' | 'onChange' | 'currentValue'
  > {}

const ApiExplorerFieldAddButtonSpecialValuesDropdown: FC<
  Props & TrackedProps
> = ({ path, onChange, currentValue, trackingId, trackingExtra }) => {
  return (
    <ApiExplorerFieldSpecialValuesDropdown
      showNullable={true}
      showEmptyString={false}
      path={path}
      onChange={onChange}
      currentValue={currentValue}
      trigger={
        <NativeButton
          className={styles['dropdown-button']}
          trackingId={trackingId}
          trackingExtra={trackingExtra}
        >
          <ChevronDown
            className={commonIconStyles['icon-fill-current-color']}
          />
        </NativeButton>
      }
    />
  );
};

export { ApiExplorerFieldAddButtonSpecialValuesDropdown };
